module.exports = __webpack_public_path__ + "img/qiantang.ea0cb3c1.png";